/* Prism & Pocket — wishlist / chase list (localStorage, no account needed). */
(function () {
  'use strict';
  var KEY = 'pp_wishlist_v1';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { count: list.length } }));
  }
  function has(handle) { return read().some(function (i) { return i.handle === handle; }); }
  function toggle(item) {
    var list = read();
    var idx = list.map(function (i) { return i.handle; }).indexOf(item.handle);
    if (idx > -1) { list.splice(idx, 1); } else { list.unshift(item); }
    write(list);
    return idx === -1; // true if added
  }
  function remove(handle) {
    write(read().filter(function (i) { return i.handle !== handle; }));
  }

  function setBtn(btn, on) {
    btn.classList.toggle('is-saved', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var label = btn.querySelector('[data-wish-label]');
    if (label) { label.textContent = on ? 'Saved to wishlist' : 'Save to wishlist'; }
  }
  function syncButtons(ctx) {
    (ctx || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      setBtn(btn, has(btn.getAttribute('data-handle')));
    });
  }
  function syncCount() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-count', n);
      el.hidden = n === 0;
    });
  }

  function renderPage() {
    var host = document.querySelector('[data-wishlist-page]');
    if (!host) return;
    var list = read();
    host.innerHTML = '';
    if (!list.length) {
      var empty = document.querySelector('[data-wishlist-empty]');
      host.innerHTML = empty ? empty.innerHTML : '<p class="text-muted" style="text-align:center">Your wishlist is empty.</p>';
      return;
    }
    var grid = document.createElement('div');
    grid.className = 'product-grid';
    list.forEach(function (item) {
      var card = document.createElement('article');
      card.className = 'product-card';
      card.innerHTML =
        '<div class="product-card__media">' +
          '<button type="button" class="wish-btn is-saved" data-wishlist-remove="' + item.handle + '" aria-label="Remove from wishlist">' +
            '<span class="wish-btn__on"><svg class="icon" viewBox="0 0 24 24" fill="currentColor"><path d="M12 21s-7.5-4.6-10-9.2C.3 8.5 2 5 5.3 5c1.9 0 3.3 1 3.7 2.4C9.4 6 10.8 5 12.7 5 16 5 17.7 8.5 16 11.8 13.5 16.4 12 21 12 21Z"/></svg></span>' +
          '</button>' +
          '<a href="' + item.url + '" class="product-card__media-link">' + (item.image ? '<img class="product-card__img product-card__img--main" src="' + item.image + '" alt="" loading="lazy">' : '') + '</a>' +
        '</div>' +
        '<div class="product-card__body">' +
          '<a href="' + item.url + '" class="product-card__title">' + item.title + '</a>' +
          '<div class="product-card__price">' + (item.price || '') + '</div>' +
        '</div>';
      grid.appendChild(card);
    });
    host.appendChild(grid);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (btn) {
      e.preventDefault();
      var added = toggle({
        handle: btn.getAttribute('data-handle'),
        title: btn.getAttribute('data-title'),
        url: btn.getAttribute('data-url'),
        image: btn.getAttribute('data-image'),
        price: btn.getAttribute('data-price')
      });
      setBtn(btn, added);
      if (added && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        btn.classList.remove('just-saved'); void btn.offsetWidth; btn.classList.add('just-saved');
      }
      return;
    }
    var rm = e.target.closest('[data-wishlist-remove]');
    if (rm) { e.preventDefault(); remove(rm.getAttribute('data-wishlist-remove')); renderPage(); syncButtons(); return; }
  });

  document.addEventListener('wishlist:change', function () { syncCount(); });

  function init() { syncButtons(); syncCount(); renderPage(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
